export default __webpack_public_path__ + "static/media/right_sidebar_arrow_active.e99de342.svg";